import LazyLoad from 'vanilla-lazyload';

(() => {
  const initLazyload = () =>
    new LazyLoad({
      elements_selector: '.lazyload',
    });
  document.addEventListener('DOMContentLoaded', initLazyload);
})();
